import { render } from "./MaterialsSlider.vue?vue&type=template&id=39598f53&scoped=true"
import script from "./MaterialsSlider.vue?vue&type=script&lang=js"
export * from "./MaterialsSlider.vue?vue&type=script&lang=js"

import "./MaterialsSlider.vue?vue&type=style&index=0&id=39598f53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39598f53"]])

export default __exports__